export default "<div class=\"wrapper wrapper-content  animated fadeInRight\">\n  <app-tag-maps-form (onsubmit)=\"save($event)\"></app-tag-maps-form>\n</div>\n";